import { useState } from 'react';
import { type ApolloError } from '@apollo/client';
import { Trans } from '@lingui/react';
import { type GqlShareholdersQuery } from '../../../graphql/react-operations';
import { type ArrayElement } from '@startuptools/common/common';
import { ShareCertificatesTable } from './ShareCertificatesTable';
import { ShareCertificatesWarning } from './ShareCeritficatesWarning';
import { Alert } from '@startuptools/ui/Alert';
import { Card } from '@startuptools/ui/Card';
import { GenericError } from '@startuptools/ui/Error';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { type GqlShareRange } from '../../../graphql/base-types.graphql';

export interface ShareCertificateRange extends GqlShareRange {
  blockNumber: number;
}

export interface ShareCertificate {
  id: string;
  shareholder: ArrayElement<GqlShareholdersQuery['shareholders']>;
  blocks: number;
  certificateIssued: boolean;
  blockNumber: number;
  ownerName: string | undefined;
  totalNumberOfShares: number;
  shareRanges: ShareCertificateRange[];
}

export const ShareCertificatesInner = ({ data, error }: { data: ShareCertificate[]; error?: ApolloError }) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [showTable, setShowTable] = useState<boolean>(data.some(d => d.certificateIssued));
  if (error) {
    return <GenericError />;
  }

  return (
    <Stack spacing={2}>
      <Typography level="h2">
        <Trans id="Share Certificates" />
      </Typography>
      {data.length < 1 && !error && (
        <Card>
          <Alert variant="outlined" color="neutral">
            <Trans id="There are no share certificates so far." />
          </Alert>
        </Card>
      )}

      {data.length >= 1 && (
        <>
          {showTable ? (
            <ShareCertificatesTable data={data} />
          ) : (
            <ShareCertificatesWarning
              onCheckboxChange={() => setIsChecked(!isChecked)}
              onButtonClick={() => setShowTable(!showTable)}
              isChecked={isChecked}
            />
          )}
        </>
      )}
    </Stack>
  );
};
